module.exports = __webpack_public_path__ + "static/media/right-arrow.311add90.svg";